import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useTranslation } from "../../languages";

const ErrorModal = ({
  isOpen,
  toggle,
  errorMessage,
  success,
  onConfirm,
  onConfirmBtn,
}) => {
  console.log({ errorMessage });
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="error-modal">
      <ModalHeader
        toggle={toggle}
        className={`${
          success ? "bg-success" : "bg-danger text-white"
        } d-flex justify-content-between`}
      >
        <div className="d-flex justify-content-between align-items-center w-100">
          <span className="text-white">
            {success ? t("success") : t("formError")}
          </span>
        </div>
      </ModalHeader>
      <ModalBody
        className={`bg-light fw-bold ${
          success ? "text-success" : "text-danger"
        }`}
      >
        <span>{errorMessage}</span>

        {success ? (
          <button
            onClick={onConfirm}
            type="button"
            className="btn btn-success d-block mt-3 mx-auto float-end"
          >
            {t("confirmCode")}
          </button>
        ) : null}
      </ModalBody>
    </Modal>
  );
};

export default ErrorModal;
